import { API_USER, AUTH_KEY } from "../utils/contants";
import apiClient from "./client";
import { getDomain } from "../utils";

const getMerchant = async () =>
  await apiClient.get<any>(`/crm/integration/viewMerchantV3?domain=${getDomain()}`);

export interface AccessTokenResponse {
  success: boolean;
  data: {
    name: string;
    access_token: string;
  };
}

export interface AccessTokenErrorResponse {
  success: boolean;
  data: {
    code: number;
    message: string;
    name: string;
    status: number;
  };
}

const getToken = async () => {
  return await apiClient.post<AccessTokenResponse & AccessTokenErrorResponse>(
    "wfm/api/auth",
    {
      name: API_USER,
      auth_key: AUTH_KEY,
    }
  );
};

const merchantApi = { getMerchant, getToken };

export default merchantApi;
